<template>
  <div>
    <el-row v-if="hasPrice">
      <el-col :span="20">
        <span>可用积分</span>
        <span>{{dataIn.studentMemberInfo.BonusPoint}}</span>
        <span>(C${{model.courseListData.calcBonusPointAmount(dataIn.studentMemberInfo.BonusPoint)}})</span>
      </el-col>
    </el-row>
    <el-row v-if="hasPrice" class="cs-auen-courseList-row">
      <el-col :span="20">

        <span>剩余积分</span>
        <span>{{totalBonusPointCostLeft}}</span>
        <span>(C${{totalBonusPointAmountLeft}})</span>

        <span v-if="!dataIn.studentMemberInfo.IsMember" class="cs-color-frenchgrey">非会员，无法使用积分</span>
      </el-col>
    </el-row>
    <el-form :model='model' class="cs-auen-courseList-form">
      <el-table :cell-class-name="cellStyle" :data="model.courseListData.data" :default-sort="{prop: 'Name', order: 'ascending'}"
        :header-row-class-name="'el-table-header'">
        <el-table-column prop="CourseName" label="已报课程" width="200"></el-table-column>
        <el-table-column v-if="!hasPrice" prop="ProfessorName" label="教授" width="100"></el-table-column>
        <el-table-column v-if="!hasPrice" prop="CourseCode" label="编码" width="100"></el-table-column>
        <!-- <el-table-column v-if="hasYearCourse" prop="YearCourseType" label="年课学期" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.IsYearCourse">
              <el-select v-if="!hasPrice" size="small" v-model="scope.row.YearCourseType" placeholder="请选择年课学期" @change="onYearCourseTypeChange(scope.row)">
                <el-option v-for="item in scope.row.YearCourseTypeList" :key="item.Value" :label="item.Text" :value="item.Value">
                </el-option>
              </el-select>
              <span v-else>{{getYearCourseTypeText(scope.row)}}</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column v-if="hasPrice" prop="Price" label="原价" width="100"></el-table-column>
        <el-table-column v-if="hasPrice" prop="DiscountPrice" label="折扣价" width="100"></el-table-column>
        <el-table-column v-if="hasPrice" prop="BonusPointCost" label="使用积分" width="160">
          <template slot-scope="scope">
            <div class="cs-auen-courseList-bonusPointCost">
              <span v-if="isReadonly">{{scope.row.BonusPointCost}}</span>
              <el-input v-else placeholder="请输入积分" size="small" :prop="'courseListData.data[' + scope.$index + '].BonusPointCost'"
                :disabled="!dataIn.studentMemberInfo.IsMember" oninput="value=value.replace(/\D/g,'')"
                v-model.number="scope.row.BonusPointCost" class="input-width" @change="onBonusPointCostChange(scope.row)">
              </el-input>
              <span
                v-if="scope.row.BonusPointCost > 0">({{model.courseListData.calcBonusPointAmount(scope.row.BonusPointCost)}})</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="" width="100" v-if="!isReadonly && !hasPrice">
          <template slot-scope="scope">
            <el-button type="text" size="small" icon="el-icon-delete" class="delete-button" @click="deleteCourse(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div v-if="hasPrice" class="cs-auen-courseList-total">
      <el-row>
        <el-col :span="6"><span>总价</span></el-col>
        <el-col :span="12"><span>C${{model.courseListData.totalPrice}}</span></el-col>
      </el-row>
      <el-row>
        <el-col :span="6"><span>折后总价</span></el-col>
        <el-col :span="12">
          <span>C${{model.courseListData.totalDiscountPrice}}</span>
          <span v-if="model.courseListData.totalPrice - model.courseListData.totalDiscountPrice > 0"
            class="cs-redLabel">(-{{model.courseListData.totalPrice - model.courseListData.totalDiscountPrice}})</span>
        </el-col>
      </el-row>
      <el-row v-if="model.courseListData.totalBonusPointCost > 0">
        <el-col :span="6"><span>总使用积分</span></el-col>
        <el-col :span="12"><span
            class="cs-redLabel">-{{model.courseListData.totalBonusPointCost}}(C${{model.courseListData.totalBonusPointAmount}})</span>
        </el-col>
      </el-row>
      <el-row v-if="model.courseListData.hasTax">
        <el-col :span="6"><span>税前合计</span></el-col>
        <el-col :span="12"><span>C${{model.courseListData.totalPreTax}}</span></el-col>
      </el-row>
      <el-row v-if="model.courseListData.hasTax">
        <el-col :span="6"><span>总税费</span></el-col>
        <el-col :span="12"><span>C${{model.courseListData.totalTax}}</span></el-col>
      </el-row>
      <el-row v-if="model.courseListData.balanceCost > 0">
        <el-col :span="6"><span>使用余额</span></el-col>
        <el-col :span="12"><span class="cs-redLabel">-C${{model.courseListData.balanceCost}}</span></el-col>
      </el-row>
      <el-row v-if="model.courseListData.enrollmentCost > 0">
        <el-col :span="6"><span>使用占位</span></el-col>
        <el-col :span="12"><span class="cs-redLabel">-C${{model.courseListData.enrollmentCost}}</span></el-col>
      </el-row>
      <el-row v-if="model.courseListData.totalPayment > 0">
        <el-col :span="6"><span>已付款</span></el-col>
        <el-col :span="12"><span class="cs-redLabel">-C${{model.courseListData.totalPayment}}</span></el-col>
      </el-row>
      <el-row>
        <el-col :span="6"><span>应付总价</span></el-col>
        <el-col :span="12"><span>C${{model.courseListData.calcAccountAmount()}}</span></el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.delete-button {
  color: red;
  margin-left: 15px;
}
.cs-auen-courseList-row {
  margin: 10px 0;
}
.cs-auen-courseList-form {
  margin-bottom: 10px;
  .el-input {
    margin: 5px 0;
  }
}
.cs-auen-courseList-total {
  .el-row {
    margin-top: 5px;
  }
}
.cs-auen-courseList-bonusPointCost {
  .el-input {
    width: 80px;
  }
}
</style>

<script>
import { getYearCourseType } from "@/config/mUtils.js";
import { CourseListEx } from "./courseListEx";

export default {
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
    hasPrice: Boolean,
    dataIn: {
      studentMemberInfo: Object,
      courseList: Object,
    },
  },
  data() {
    return {
      yearCourseTypeAllList:[],
      model: {
        courseListData: new CourseListEx([]),
      },
    };
  },
  components: {},
  computed: {
    //剩余积分
    totalBonusPointCostLeft: function () {
      let total =
        this.dataIn.studentMemberInfo.BonusPoint -
        this.model.courseListData.totalBonusPointCost;
      if (total < 0) {
        total = 0;
      }
      return total;
    },
    //剩余积分对应金额
    totalBonusPointAmountLeft: function () {
      return this.model.courseListData.calcBonusPointAmount(
        this.totalBonusPointCostLeft
      );
    },
    hasYearCourse: function () {
      let yearCourses = this.model.courseListData.data.filter(
        (i) => i.IsYearCourse
      );
      return yearCourses.length > 0;
    },
  },
  created() {
    this.yearCourseTypeAllList = getYearCourseType();
    this.init();
  },
  methods: {
    init() {
      if (!!this.dataIn && !!this.dataIn.courseList) {
        this.model.courseListData = this.dataIn.courseList;
      }
    },
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    deleteCourse(row) {
      this.$confirm(`您确认要删除该课程${row.CourseName}吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("delete", row.Id);
        })
        .catch(() => {});
    },
    onYearCourseTypeChange(row){

    },
    onBonusPointCostChange(row) {
      let isValid = true;
      let message = "";
      if (row.BonusPointCost < 0) {
        isValid = false;
        message = "不能输入负数";
      } else if (
        this.model.courseListData.totalBonusPointCost >
        this.dataIn.studentMemberInfo.BonusPoint
      ) {
        isValid = false;
        message = "总使用积分不能大于可用积分";
      } else {
        message = this.validatePrice(row);
        if (message) {
          isValid = false;
        }
      }

      if (!isValid) {
        row.BonusPointCost = 0;
        this.$message.warning(message);
      } else {
        this.$emit("edit");
      }
    },
    validatePrice(row) {
      let bonusPointAmount = this.model.courseListData.calcBonusPointAmount(
        row.BonusPointCost
      );
      if (bonusPointAmount > row.DiscountPrice) {
        return `使用积分${row.BonusPointCost}(C$${bonusPointAmount.toFixed(
          2
        )})不能大于课程折扣价${row.DiscountPrice.toFixed(2)}`;
      }
      return "";
    },
    reset() {
      if (this.model.courseListData && this.model.courseListData.data) {
        this.model.courseListData.data.forEach((element) => {
          element.BonusPointCost = 0;
        });
      }
    },
    getYearCourseTypeText(row) {
        let item = this.yearCourseTypeAllList.find(
          i => i.Value == row.YearCourseType
        );
        if (!!item) {
          return item.Text;
        }
      return "";
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/autonomousEnrolment/workflow/courseList.vue